<template>
  <div class="base-report report-payment-day">
    <div class="filter">
      <el-form inline>
        <el-select v-model="searchForm.target" size="mini" >
          <el-option
            v-for="item in targets"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="searchForm.from_date"
          type="date"
          size="mini"
          placeholder="開始日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-date-picker
          v-model="searchForm.to_date"
          type="date"
          size="mini"
          placeholder="終了日"
          value-format="yyyy-MM-dd"
          :clearable="false">
        </el-date-picker>
        <el-button size="mini" type="primary" @click="fetchData" :disabled="isLoading">表示</el-button>
        <div style="float: right; padding-right: 20px;">
          <el-button v-show="$store.getters.isPC && screenData.length>0" size="mini" type="success" icon="el-icon-download" @click="exportCSV">ダウンロード</el-button>
        </div>
      </el-form>
    </div>
    <div class="table_data" v-loading="isLoading">
      <template v-if="screenData.length>0">
        <el-table
          :data="screenData"
          border
          stripe
          show-summary
          height="100%"
          :summary-method="getSummaries">

          <template v-for="(header, index) in tableSetting">
            <template v-if="!Array.isArray(header)">
              <el-table-column
                :key=header.prop
                :label=header.label
                :prop=header.prop
                :formatter="formatter"
                :fixed=header.fixed
                :align=header.align
                :sortable=header.sortable
                :min-width=header.width>
                <template v-if="Array.isArray(tableSetting[index + 1])">
                  <template v-for="(subheader, subindex) in tableSetting[index + 1]">
                    <el-table-column
                    :key="subindex"
                    :label=subheader.label
                    :prop=subheader.prop
                    :min-width=subheader.width
                    align="right"
                    :sortable=subheader.sortable
                    :formatter="formatter">
                    </el-table-column>
                  </template>
                </template>
              </el-table-column>
            </template>
          </template>
        </el-table>
      </template>
      <div v-else v-show="noData">
        データがありません。<br>
        条件を変えて再度「表示」ボタンを押してください。
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import utils from '@/misc/utils.js'
import addFigure from '@/misc/addFigure.js'
import downloadCSV from '@/misc/downloadCSV.js'

import {mapGetters} from 'vuex'

export default {
  name: 'ReportPaymentDay',
  data () {
    const targetType = {
      sum: 1,
      avg: 2,
    }
    return {
      rounding: null,
      isLoading: false,
      noData: false,
      targetType: {...targetType},
      targets: [{value: targetType.sum, label: '合計'}, {value: targetType.avg, label: '平均'}],
      staticSetting: [
        {label: '曜日', prop: 'weekdayName', align: 'center', fixed: true, width: '130px'},
        {label: '日数', prop: 'number', align: 'center', fixed: true, width: '80px'},
      ],
      tableSetting: [],
      searchForm: {
        target: targetType.sum,
        from_date: null,
        to_date: null,
      },
      currentTarget: targetType.sum,
      headerParent: [],
      items: [],
      orgData: [],
      totalDic: {},
      totalData: [],
      csv_filename: '曜日売上.csv',
    }
  },
  computed: {
    ...mapGetters('report', ['roundingFunction']),
    screenData: function () {
      let result = []
      this.totalDic.number = 0

      this.orgData.forEach((data) => {
        let tmp = {}
        tmp.weekdayName = data.name
        tmp.number = data.numberOfDay
        this.totalDic.number += data.numberOfDay || 0
        data.data.forEach((record, index) => {
          if (this.headerParent.indexOf(record.timezoneName) === -1) {
            this.headerParent.push(record.timezoneName)
          }

          let salesExcludeTaxAvg = 0
          let partyAvg = 0
          let personAvg = 0
          let stayAvg = 0
          Object.entries(record).forEach(([attr, value]) => {
            if (!isNaN(value)) {
              if (!this.totalDic[`${attr}_${record.timezoneName}`]) {
                this.totalDic[`${attr}_${record.timezoneName}`] = 0
              }
              this.totalDic[`${attr}_${record.timezoneName}`] += this.rounding(value) || 0
            }
            switch (this.currentTarget) {
              case this.targetType.sum:
                switch (attr) {
                  case 'stay':
                    value = utils.divide(record.stay, record.party)
                    break
                  default:
                    break
                }
                break
              case this.targetType.avg:
                switch (attr) {
                  case 'partySales':
                    salesExcludeTaxAvg = this.rounding(utils.divide(record.salesExcludeTax, tmp.number))
                    partyAvg = this.rounding(utils.divide(record.party, tmp.number))
                    value = utils.divide(salesExcludeTaxAvg, partyAvg)
                    break
                  case 'personSales':
                    salesExcludeTaxAvg = this.rounding(utils.divide(record.salesExcludeTax, tmp.number))
                    personAvg = this.rounding(utils.divide(record.person, tmp.number))
                    value = utils.divide(salesExcludeTaxAvg, personAvg)
                    break
                  case 'stay':
                    stayAvg = this.rounding(utils.divide(record.stay, tmp.number))
                    partyAvg = this.rounding(utils.divide(record.party, tmp.number))
                    value = utils.divide(stayAvg, partyAvg)
                    break
                  default:
                    value = utils.divide(value, tmp['number'])
                    break
                }
                break
            }
            tmp[`${attr}_${record.timezoneName}`] = value
          })
        })
        result.push(tmp)
      })

      this.updateTableHeader()
      return result
    },
  },
  filters: {
    date (value) {
      return moment(value).format('YYYY/MM/DD')
    },
  },
  methods: {
    fetchData () {
      this.isLoading = true
      this.noData = false
      this.items = []
      this.totalDic = {}
      this.orgData = []
      this.headerParent = []
      // this.totalStay = {}
      this.currentTarget = this.searchForm.target
      switch (this.currentTarget) {
        case this.targetType.sum:
          this.headerParent = ['合計']
          break
        case this.targetType.avg:
          this.headerParent = ['平均']
          break
      }
      this.$request.reports.salesWeekdays(this.searchForm.from_date, this.searchForm.to_date, this.searchForm.target).then(res => {
        this.items = res.body

        for (let record of this.items.records) {
          if (record.data) {
            switch (record.type) {
              case 'header':
                this.headerParent.push(...record.data)
                break
              case 'record':
                this.orgData.push(record)
                break
              default:
                break
            }
          }
        }
      }, err => {
        console.log(err)
      }).finally(() => {
        this.isLoading = false
        this.noData = !this.screenData.length
      })
    },
    updateTableHeader () {
      this.tableSetting = []
      this.tableSetting.push(...this.staticSetting)
      for (let header of this.headerParent) {
        this.tableSetting.push({
          label: header,
        })
        this.tableSetting.push([
          {label: '売上(税抜)', prop: `salesExcludeTax_${header}`, align: 'right', sortable: true, width: '120px'},
          {label: '組数', prop: `party_${header}`, align: 'right', sortable: true, width: '80px'},
          {label: '組単価', prop: `partySales_${header}`, align: 'right', sortable: true, width: '100px'},
          {label: '客数', prop: `person_${header}`, align: 'right', sortable: true, width: '80px'},
          {label: '客単価', prop: `personSales_${header}`, align: 'right', sortable: true, width: '100px'},
          {label: '男性', prop: `male_${header}`, align: 'right', sortable: true, width: '80px'},
          {label: '女性', prop: `female_${header}`, align: 'right', sortable: true, width: '80px'},
          {label: '滞在時間', prop: `stay_${header}`, align: 'right', sortable: true, width: '110px'},
        ])
      }
    },
    getSummaries ({columns, data}) {
      columns.forEach((column, index) => {
        if (index === 0) {
          this.totalData[index] = '合計'
          return true
        }
        let prop = columns[index].property
        let value = this.totalDic[prop]
        switch (this.currentTarget) {
          case this.targetType.sum:
            value = this.totalDic[prop]
            break
          case this.targetType.avg:
            if (prop !== 'number') {
              value = this.totalDic[prop] / this.totalDic.number
            }
            break
        }

        if (prop.match(/^partySales_/g)) {
          let suffix = prop.replace(/^partySales_/, '')
          value = utils.divide(this.totalDic[`salesExcludeTax_${suffix}`], this.totalDic[`party_${suffix}`])
        } else if (prop.match(/^personSales_/g)) {
          let suffix = prop.replace(/^personSales_/, '')
          value = utils.divide(this.totalDic[`salesExcludeTax_${suffix}`], this.totalDic[`person_${suffix}`])
        } else if (prop.match(/^stay_/g)) {
          let suffix = prop.replace(/^stay_/, '')
          value = utils.divide(this.totalDic[`stay_${suffix}`], this.totalDic[`party_${suffix}`])
        }

        this.totalData[index] = this.formatData(prop, value)
      })
      return this.totalData
    },
    exportCSV () {
      let header = []
      let keyList = []
      for (let tableHeader of this.tableSetting) {
        if (Array.isArray(tableHeader)) {
          let preHeader = header.pop()
          // check padding
          if (!preHeader) {
            continue
          }
          for (let subHeader of tableHeader) {
            if (subHeader.prop) {
              keyList.push(subHeader.prop)
            }
            header.push(`${preHeader}-${subHeader.label}`)
          }
        } else {
          if (tableHeader.prop) {
            keyList.push(tableHeader.prop)
          }
          header.push(tableHeader.label)
        }
      }
      let data = []
      for (let record of this.screenData) {
        let tmp = []
        for (let key of keyList) {
          tmp.push(this.formatData(key, record[key]))
        }
        data.push(tmp)
      }

      downloadCSV(this.csv_filename, header, data, this.totalData)
    },
    formatter (row, column) {
      let key = column.property
      return this.formatData(key, row[key])
    },
    formatData (key, value) {
      if (key.match(/^stay_/g)) {
        return utils.formatStay(value)
      }

      switch (key) {
        case 'weekdayName':
          return value
        default:
          value = !isNaN(value) ? value : 0
          return addFigure(this.rounding((value)))
      }
    },
  },
  created () {
    this.rounding = this.roundingFunction
  },
  mounted () {
    this.searchForm.from_date = moment().date(1).format('YYYY-MM-DD')
    this.searchForm.to_date = moment().format('YYYY-MM-DD')
  },
}
</script>

<style lang="sass">
@import "static/sass/report/common.sass"
</style>



// WEBPACK FOOTER //
// src/components/Report/ReportSalesWeekday.vue